import { useUserContext } from "@contexts/user/UserContext";

export default function useIsRecognitionDisabled() {
    const { context } = useUserContext();

    return context?.isRecognitionDisabled;
}